import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuditItemLogService } from 'app/service/audit-item-log-service';
import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { CommonDTO } from './../../../model/common-dto';
import { CustomMessages } from '@shared';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'app/service/common.service';
import { ReturnLog } from 'app/model/return-log';

export interface PeriodicElement {
  remark: string;
  pdca: string;
  updatedAt: string;
  updatedBy: string;
  type: string;
}

@Component({
  selector: 'app-returnlog',
  templateUrl: './returnlog.component.html',
  styleUrls: ['./returnlog.component.scss']
})
export class ReturnlogComponent implements OnInit {

  public styleObj = {
    "vertical-align": "text-top",
  };
  public styleObj2 = {
    "vertical-align": "text-top",
  };
  [x: string]: any;
  displayedColumns: string[] = ['orderId', 'remark', 'pdca', 'updatedBy', 'updatedOn'/*, 'type'*/];
  dataSource = new MatTableDataSource();
  ELEMENT_DATA: PeriodicElement[] = [];
  escalationChange: boolean = false;
  observationApplicableChange: boolean = false;
  ratingMstIdChange: boolean = false;
  includeInReportChange: boolean = false;
  auditorObservationChange: boolean = false;
  impactCommentsChange: boolean = false;
  recommendationChange: boolean = false;
  modifiedByChange: boolean = false;
  modifiedOnChange: boolean = false;
  managementCommentChange: boolean = false;
  targetDateChange: boolean = false;
  pdcaActionChange: boolean = false;
  persistenceCommentsChange: boolean = false;
  revisedTargetDateChange: boolean = false;
  rcoCommentsChange: boolean = false;
  noList: boolean = true;
  parsedJson: any;
  noRecordFound: boolean = false;
  sectionId: any;
  scopeDesc: string;
  departmentName: string;
  sectionName: string;
  auditorBenchAuditDetailScopeDetailList: AuditorBenchAuditDetailScopeDetailDTO[];
  commonDTO: CommonDTO = new CommonDTO();
  @Output() closePanelAudiItemLog: EventEmitter<boolean> = new EventEmitter();
  @Input() auditItemId: string;
  @Input() isWorkflowBased: boolean;
  @Input() callingType: string;
  returnLog: ReturnLog[];

  constructor(private commonService: CommonService, private auditItemLogService: AuditItemLogService, private customMessages: CustomMessages) { }

  ngOnInit() {
    this.getAuditItemLogList();
  }
  getAuditItemLogList() {

    this.commonDTO.searchValue = this.callingType;
    this.commonDTO.scopeId = this.auditItemId;

    if (this.commonDTO.searchValue === 'Auditor') {
      this.displayedColumns = ['orderId', 'remark', 'pdca', 'updatedBy', 'updatedOn'/*, 'type'*/];
    } else if (this.commonDTO.searchValue === 'Auditee') {
      this.displayedColumns = ['orderId', 'remark', 'pdca', 'updatedBy', 'updatedOn'/*, 'type'*/];
    }

    this.getReturnLogData();
  }

  getReturnLogData() {
    this.commonService.getReturnLogList(this.commonDTO)
      .subscribe(data => {
        if (data == null || data == "") {
          this.noList = true;
        }
        else {
          this.noList = false;
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.returnLog = this.parsedJson;
          if (this.returnLog != null && this.returnLog != undefined) {
            this.sectionId = this.returnLog[0].sectionId;
            this.sectionName = this.returnLog[0].sectionName;
            this.departmentName = this.returnLog[0].departmentName;
            this.scopeDesc = this.returnLog[0].scopeDescription;
          }
          this.noRecordFound = false;
          this.ELEMENT_DATA = this.returnLog;
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        }
      }, (error) => {
        this.customMessages.showErrorMessage(error.error.msgId, error.error.message);
      });
  }

  closed() {
    this.closePanelAudiItemLog.emit(false);
  }

}
